import { useQuery } from '@apollo/client';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { IconButton } from '@mui/material';
import { useNavigate } from '@tanstack/react-router';
import React, { type MouseEvent, useState } from 'react';
import styles from 'src/Administration/TopNavbar/TopNavbarStyles';
import staffStatus from 'src/api/admin/staffStatus';
import { StyledContextMenu } from 'src/components/menus/StyledContextMenu';
import type { ActionItem } from 'src/constants';
import { HOME_PATH } from 'src/constants';
import { useLogout } from '../../helpers/authHelper';

interface StaffStatusData {
  me: {
    firstName: string;
    lastName: string;
    user: {
      username: string;
    };
  };
}

const actions: ActionItem[] = [
  { label: 'Library', icon: <HomeOutlinedIcon style={{ color: 'currentColor' }} /> },
  { label: 'Jobs', icon: <WorkOutlineIcon style={{ color: 'currentColor' }} /> },
  { label: 'Logout', icon: <LogoutIcon style={{ color: 'currentColor' }} /> },
];

const AdminNavBarUserName = (): React.ReactElement => {
  const classes = styles();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { data: staffStatusData } = useQuery<StaffStatusData>(staffStatus, {
    fetchPolicy: 'cache-and-network',
  });

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const logout = useLogout(handleClose);

  const homePageHandle = (): void => {
    navigate({ to: HOME_PATH });
  };

  const jobsHandle = (): void => {
    navigate({ to: '/jobs' });
  };

  const handleAction = (action: ActionItem): void => {
    if (action.label === 'Library') homePageHandle();
    else if (action.label === 'Jobs') jobsHandle();
    else if (action.label === 'Logout') logout();
    handleClose();
  };

  const userName =
    staffStatusData?.me.firstName === '' && staffStatusData?.me.lastName === ''
      ? staffStatusData?.me.user.username
      : `${staffStatusData?.me.firstName} ${staffStatusData?.me.lastName}`;

  return (
    <div className={classes.root}>
      <IconButton onClick={handleClick} size="large">
        <AccountCircleIcon color="disabled" />
      </IconButton>
      <StyledContextMenu
        actions={actions}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onAction={handleAction}
        dangerLabels={['Logout']}
        placement="bottom-end"
        id="profile-menu"
        headerContent={<span>{userName}</span>}
      />
    </div>
  );
};

export default AdminNavBarUserName;
